import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3abd3e8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Ordenar Posições dos Itens de Análise", -1))
const _hoisted_2 = { class: "drop-zone" }
const _hoisted_3 = { class: "w-64" }

import { AnalysisItem } from '@/models/analysis-item';
import { api } from '@/utils';
import { ref } from 'vue';
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import {
  AnalysisItemOrder,
  AnalysisItemOrderForm,
  toRequestDataOrder,
} from './models/analysis-item-order';

interface Props {
  analysisItems: AnalysisItem[];
}

interface Emits {
  (e: 'open'): void;
  (e: 'close'): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    analysisItems: null
  },
  emits: ["open", "close"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'open'): void;
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  analysisItems: AnalysisItem[];
}

const quasar = useQuasar();



const show = ref<boolean>(false);

let order: AnalysisItem[] = [];

const open = () => {
  show.value = true;
  emit('open');
};

const close = () => {
  show.value = false;
  emit('close');
};

const log = (event: any) => {
  console.log(event);
};

const checkMove = (event: any) => {
  order = event.relatedContext.list;
};

const onEnd = (event: any) => {
  ordination();
};

const ordination = () => {
  const analysisItemOrder: AnalysisItemOrder[] = [];
  order.forEach((value: AnalysisItem, index: number) => {
    analysisItemOrder.push({ id: value.id, order: index + 1 });
  });
  const itemsOrder: AnalysisItemOrderForm = { items_order: analysisItemOrder };
  localStorage.setItem('itemsOrder', JSON.stringify(itemsOrder));
};

const save = () => {
  quasar.loading.show();
  const data = localStorage.getItem('itemsOrder') ?? '';
  const itemsOrder: AnalysisItemOrderForm = JSON.parse(data);

  api
    .put('analysis-item-order', { ...toRequestDataOrder(itemsOrder) })
    .then(() => {
      quasar.notify({
        type: 'positive',
        message: 'Ordem dos itens salvo!',
      });
      localStorage.removeItem('itemsOrder');
      quasar.loading.hide();
      close();
    })
    .catch((error) => {
      if (error.response.status === 422) {
        quasar.notify({
          type: 'warning',
          message: error.response.data.message,
        });
      } else {
        quasar.notify({
          type: 'negative',
          message: error.response.data.message,
        });
        console.log('Erro ao salvar ordem dos itens.', error.response);
      }
    });
  quasar.loading.hide();
};

expose({ open, close });

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "view-modal" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_draggable, {
                    class: "",
                    list: __props.analysisItems,
                    sort: true,
                    onEnd: onEnd,
                    onChange: log,
                    move: checkMove
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.analysisItems, (element, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "drag-el bg-primary text-white",
                          key: index
                        }, _toDisplayString(element.text), 1))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["list"])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                flat: "",
                label: "Fechar",
                onClick: close
              }),
              _createVNode(_component_q_btn, {
                color: "primary",
                label: "Salvar",
                onClick: save
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})